import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * Tracks telemetry events using PostHog.
 * This service is used to track events and page views in the application, but differs from the analytics service
 * in that it is specifically designed for internal analytics purposes (Kyudo to review how users are using insight/PWA).
 * The analytics service is used for tracking events and page views that our brands can view on the Insight dashboard.
 */
@Injectable({
  providedIn: 'root',
})
export class TelemetryService {
  posthog = null;
  isInitialized: boolean = false;

  constructor() {}

  async init() {
    if (environment.POSTHOG_KEY && environment.POSTHOG_HOST) {
      this.posthog = (await import('posthog-js')).default;
      this.posthog.init(environment.POSTHOG_KEY, {
        api_host: environment.POSTHOG_HOST,
        capture_pageview: false, // tracks it manually as it's a single page app
        person_profiles: 'always', // tracks all users, not just the logged in ones
        session_recording: {
          // We need this to be able to record session replays for builder
          recordCrossOriginIframes: true,
        },
      });
      this.isInitialized = true;
    } else {
      console.warn(
        'PostHog key or host not provided. Telemetry will not be initialized.'
      );
    }
  }

  trackPageView(url: string) {
    if (this.isInitialized) {
      this.posthog.capture('$pageview');
    }
  }

  trackCustomEvent(eventName: string, properties?: any) {
    if (this.isInitialized) {
      this.posthog.capture(eventName, properties);
    }
  }
}
